import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post('/resume_documents/', data, {
    headers: {
      'Content-Type': `multipart/form-data;`,
    },
  });
};

const filter = async (id) => {
  return await httpClient.get(
    `/resume_documents/latest/?filter[tercero]=${id}`,
  );
};

export { post, filter };
